// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
  --mat-form-field-container-text-size: 12px;
  --mat-select-trigger-text-size: 12px;
}

.form-container {
  padding: 24px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: white;
}

.product-input-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 18px;
}

.form-inputs {
  flex: 1 1 calc(50% - 18px);
  min-width: 0;
}

.width-100,
.w-100 {
  flex-basis: 100%;
}

mat-form-field {
  display: block;
  width: 100%;
}

.field-display {
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  padding: 12px;
}

.field-display > span:first-child {
  display: block;
  color: #7d8a9d;
  margin-bottom: 8px;
}

.error-msg {
  display: block;
  color: #d92d20;
  font-size: 11px;
  margin-top: 6px;
}

.select-label-text {
  display: block;
  font-size: 11px;
  color: #53647a;
  margin-bottom: 6px;
}

.title3,
.title {
  font-size: 14px;
  font-weight: 600;
  color: #172b46;
}

.note-container {
  padding: 12px 16px;
  background: #fff8e6;
  border-radius: 8px;
  margin-bottom: 16px;
}

mat-accordion {
  display: block;
  margin: 20px 0;
}

mat-expansion-panel {
  box-shadow: none !important;
  border: 1px solid #e2e9f2;
  border-radius: 8px !important;
  margin-bottom: 12px;
}

.product-bottom-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-top: 20px;
  margin-top: 24px;
  border-top: 1px solid #edf1f6;
}

.product-bottom-container mat-spinner {
  display: inline-block;
  margin-inline-end: 8px;
}

.prev {
  cursor: pointer;
  color: var(--primary-color);
}

.listing-table,
.table-scroll {
  overflow: auto;
}

table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

th,
td {
  padding: 12px;
  text-align: start;
  border-bottom: 1px solid #edf1f6;
}

th {
  background: #f8fafd;
  color: #7d8a9d;
  font-weight: 500;
}

.preview-image,
.related-preview-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 8px;
}

.image-container,
.variation-image {
  display: inline-flex;
  max-width: 160px;
  padding: 8px;
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  margin: 4px;
}

.image-container img,
.variation-image img {
  max-width: 100%;
  max-height: 140px;
  object-fit: contain;
}

.image-section {
  padding: 16px;
  background: #f8fafd;
  border-radius: 8px;
}

.checkbox-wrap,
.sku-check {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.checkbox-content {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.product-button {
  display: flex;
  justify-content: flex-end;
}

.image-upload-container,
.file-upload-container {
  border: 1px dashed #dce5ef;
  border-radius: 8px;
  padding: 20px;
}

.tag-cover-box {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.grey-box {
  padding: 6px 10px;
  background: #f1f6fd;
  border-radius: 6px;
}

.price-group-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 16px 0;
}

dt {
  color: #7d8a9d;
  font-size: 11px;
}

dd {
  margin: 6px 0;
}

@media (max-width: 650px) {
  .form-container {
    padding: 16px;
  }
  .form-inputs {
    flex-basis: 100%;
  }
  .product-input-wrap {
    gap: 14px;
  }
}
.product-detail-container .form-container {
  padding: 1.5625rem 0;
}
.product-detail-container .product-input-wrap {
  display: flex;
  place-content: space-between;
}
.product-detail-container .product-input-wrap .form-inputs {
  padding-bottom: 0.75rem;
  position: relative;
}
.product-detail-container .product-input-wrap .form-inputs ion-item .country-code {
  display: none;
}
.product-detail-container .product-input-wrap .form-inputs ion-item.item-has-value .country-code,
.product-detail-container .product-input-wrap .form-inputs ion-item.item-has-focus .country-code {
  display: flex;
}
.product-detail-container .product-input-wrap .form-inputs ion-label {
  letter-spacing: 0 !important;
  color: var(--ion-color-secondary-black) !important;
  text-transform: uppercase !important;
  opacity: 1 !important;
  font-size: 0.75rem !important;
}
.product-detail-container .product-input-wrap .input-div {
  width: 49.2%;
}
.product-detail-container .product-input-wrap .width-100 {
  width: 100%;
}
.product-detail-container .product-input-wrap .sku-check {
  display: flex;
  padding: 0.625rem 0 0;
  width: 60px;
  justify-content: space-between;
  align-items: center;
}
.product-detail-container .product-input-wrap .sku-check ion-label {
  font-size: 1rem !important;
  color: var(--ion-color-primary-black) !important;
  text-transform: none !important;
}
.product-detail-container .product-input-wrap .sku-check ion-checkbox::part(container) {
  border: 1px solid #D5DADC;
}
.product-detail-container .product-input-wrap .checkbox-wrap .title3 {
  font-size: 1rem;
  font-weight: bold;
  color: var(--ion-color-primary-black);
  margin: 0.5rem 0 0.625rem;
  text-transform: capitalize;
}
.product-detail-container .product-input-wrap .checkbox-wrap .label2 {
  font-size: 0.875rem;
  color: var(--ion-color-secondary-black);
  margin: 0;
}
.product-detail-container .product-input-wrap .checkbox-wrap .d-flex {
  display: flex;
  justify-content: space-between;
}
.product-detail-container .product-input-wrap .checkbox-wrap .border_class {
  border: 1px solid var(--ion-divider);
  padding: 0 1.25rem;
  height: 50px;
  display: flex;
  align-items: center;
  width: 49%;
}
.product-detail-container .product-input-wrap .checkbox-wrap .display-div {
  display: flex;
  align-items: center;
}
.product-detail-container .product-input-wrap .checkbox-wrap .display-div .icon-holder {
  display: contents;
}
.product-detail-container .product-input-wrap .checkbox-wrap .radio-div {
  border: 1px solid var(--ion-divider);
  padding: 12px;
  border-radius: 100%;
}
.product-detail-container .product-input-wrap .checkbox-wrap .radio-size {
  height: 1.5rem;
  width: 1.5rem;
}
.product-detail-container .img-wrap h2 {
  font-size: 1rem;
  color: var(--ion-color-primary-black);
  font-weight: bold;
  margin-top: 0.3125rem;
  display: flex;
  position: relative;
  text-transform: capitalize;
}
.product-detail-container .img-wrap h2 ion-text {
  font-weight: normal !important;
  font-size: 0.875rem !important;
  text-transform: none !important;
}
.product-detail-container .img-wrap .uploaded-image-container {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.25rem;
  row-gap: 1.25rem;
}
.product-detail-container .img-wrap .uploaded-image-container .image-card {
  width: 224px;
  height: 224px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-detail-container .img-wrap .uploaded-image-container .image-card .preview-image {
  max-height: inherit;
}
.product-detail-container .img-wrap .uploaded-image-container .image-card .icon-wrap {
  position: absolute;
  right: 8%;
  bottom: 7%;
  display: flex;
  cursor: pointer;
}
.product-detail-container .img-wrap .uploaded-image-container .image-card .icon-wrap div {
  background: #fff;
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-detail-container .img-wrap .uploaded-image-container .upload-wrap {
  border: 1px solid #D5DADC;
  padding: 0.9375rem;
}
.product-detail-container .img-wrap .uploaded-image-container .upload-wrap div {
  background: #F0F3F4;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product-detail-container .img-wrap .uploaded-image-container .upload-wrap div ion-button {
  width: 90px;
  height: 38px;
}
.product-detail-container .img-wrap .uploaded-image-container .upload-wrap div ion-button::part(native) {
  box-shadow: none;
  border-radius: 0;
}
.product-detail-container .product-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 1.125rem;
}
.product-detail-container .product-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.product-detail-container .product-bottom-container .cancel:hover {
  font-weight: 600;
}
.product-detail-container .product-bottom-container .product-button ion-button {
  --background: var(--ion-color-primary);
  width: 100px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}

.arabic-class textarea,
.arabic-class input {
  text-align: right;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.calendar-icon {
  margin: auto !important;
  cursor: pointer;
}

ng-select {
  width: 100% !important;
}

.custom-dd-tags {
  background: var(--ion-light-grey);
  padding: 0.125rem 0.625rem;
}
.custom-dd-tags .custom-tags-label {
  font-size: 0.875rem;
}
.custom-dd-tags img {
  margin: auto !important;
}
.custom-dd-tags .color-thumbnail {
  height: 1.1875rem;
  width: 1.1875rem;
  display: inline-block;
  vertical-align: sub;
}

.selected-options-container {
  position: absolute;
  bottom: 0.375rem;
}

.add-warehouse-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.warehouse-row {
  display: flex;
  justify-content: space-between;
}

.listing-table {
  padding: 0 0 1.25rem;
  overflow: auto;
}
.listing-table .table {
  width: 100%;
}
.listing-table .table .column-heading {
  font-weight: 500;
  font-size: 0.975rem;
  line-height: 1rem;
  text-transform: uppercase;
  color: var(--ion-grey1);
  padding: 0.5625rem 0.5625rem 0.5625rem 0;
}
.listing-table .table thead th:last-child {
  padding: 0.5625rem;
}
.listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.listing-table .table .table-body .table-row td {
  padding: 0.5625rem 0.5625rem 0.5625rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--ion-color-primary-black);
  word-break: break-word;
}
.listing-table .table .table-body .table-row td:last-child {
  padding: 0.5625rem;
}
.listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}
.listing-table .table .table-body .table-row .toggle-edit-block {
  display: flex;
}
.listing-table .table .table-body .table-row .toggle-edit-block .edit-img-icon {
  cursor: pointer;
}
.listing-table .table .table-body .table-row .toggle-edit-block .cursor-disabled {
  cursor: not-allowed;
}

.cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  cursor: pointer;
}
.cancel:hover {
  font-weight: 600;
}

.warehouse-dd {
  height: 60%;
}

.file-input {
  position: absolute;
  width: 1px;
  opacity: 0;
}

.image-container {
  min-height: 224px;
  max-height: 224px;
}

.document-upload-container {
  border: 1px solid #D5DADC;
}

.accordian-label {
  text-transform: capitalize;
}

.tooltip {
  position: relative;
  display: contents;
}

.remove-doc-icon {
  cursor: pointer;
  vertical-align: middle;
}

.tooltip .tooltiptext {
  visibility: hidden;
  max-width: 200px;
  min-width: fit-content;
  background: #000;
  color: #fff;
  text-align: center;
  border-radius: 0.375rem;
  padding: 0.125rem 0.5rem;
  top: 3.5rem;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.more-info-tooltip {
  margin-top: 3px;
}

.note-container {
  font-size: 1rem;
  color: var(--ion-grey1);
}

.uploaded-file-container {
  display: flex;
}
.uploaded-file-container .tooltip {
  display: inline-block;
}

.uploaded-file {
  position: relative;
}
.uploaded-file .uploaded-file-name {
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.info-rtl .more-info-tooltiptext {
  left: unset !important;
  right: 0 !important;
}

.weight {
  text-transform: none !important;
}

.relatedProduct {
  padding-top: 1.5rem;
  padding-bottom: 2rem;
  background-color: var(--ion-color-gray-20);
}
.relatedProduct .h-50 {
  height: 50px;
}
.relatedProduct .w-40 {
  width: 44% !important;
}
.relatedProduct .filters-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.75rem;
}
.relatedProduct .filters-icon .search-icon {
  margin-top: 0.1rem;
  padding-right: 0.5rem;
}
.relatedProduct .space-between {
  display: flex;
  justify-content: space-between;
  padding-bottom: 2rem;
  background-color: var(--ion-color-gray-20);
}
.relatedProduct .space-between .status-label {
  font-size: 0.9rem;
  color: var(--ion-color-primary-black);
  font-weight: bold;
  text-transform: capitalize;
}
.relatedProduct .space-between .status-label .status-dropdown-div {
  margin-top: 0.5rem;
}
.relatedProduct .filter-div {
  display: flex;
  margin-top: 0.5rem;
}
.relatedProduct .filter-div img {
  max-width: fit-content;
}
.relatedProduct .filter-div .filter-icon {
  display: flex;
  align-items: center;
  padding: 0 0.5625rem;
  cursor: pointer;
}
.relatedProduct .filter-div .filter-label {
  cursor: pointer;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.relatedProduct .filter-div .close-label {
  color: var(--ion-color-primary-black) !important;
}
.relatedProduct .related_list {
  max-height: 280px;
  background-color: var(--ion-color-gray-20);
}
.relatedProduct .iconColor {
  color: var(--ion-app-primary) !important;
  margin-right: -40px;
}
.relatedProduct h2 {
  font-size: 1rem;
  color: var(--ion-color-primary-black);
  font-weight: bold;
  margin-top: 0.3125rem;
  display: flex;
  position: relative;
  text-transform: capitalize;
}
.relatedProduct h2 ion-text {
  font-weight: normal !important;
  font-size: 0.875rem !important;
  text-transform: none !important;
}

.preview-image {
  width: 50px;
  height: 50px;
}

.float-right {
  float: right;
}

.count {
  height: 50px;
  font-weight: normal !important;
  font-size: 0.875rem !important;
  text-transform: none !important;
  color: var(--ion-color-primary-black);
}
.count span {
  font-weight: bold;
}

.justify-center {
  justify-content: center !important;
}

.tag-cover-box {
  border: 1px solid var(--ion-border-color);
  border-radius: 5px;
  overflow: auto;
  flex-wrap: wrap;
  display: flex;
  max-height: 150px;
  overflow: auto;
}
.tag-cover-box .grey-box {
  border-radius: 5px;
  opacity: 1;
  background: rgba(41, 53, 71, 0.0470588235);
  width: fit-content;
  height: fit-content;
  padding: 4px 10px 5px 10px;
  background: #f5f5f5;
  border: 1px solid #f0f0f0;
  align-items: center;
  margin: 10px;
  display: inline;
  position: relative;
}
.tag-cover-box .grey-box span {
  padding-right: 16px;
}
.tag-cover-box .grey-box .close {
  height: 15px;
  position: absolute;
  cursor: pointer;
  top: 6px;
  right: -12px;
}

.addTag-Btn-ltr {
  position: absolute;
  top: 8px;
  z-index: 9;
  right: 7px;
}

.addTag-Btn-rtl {
  position: absolute;
  top: 8px;
  z-index: 9;
  left: 7px;
}

.saveRelated {
  height: 50px;
  margin-top: -20px;
}

.float-left {
  float: left;
}

@media screen and (max-width: 768px) {
  .relatedProduct .w-40 {
    width: 35% !important;
  }
}
.editTag-ltr {
  float: right;
  padding-bottom: 20px;
}

.editTag-rtl {
  float: left;
  padding-bottom: 20px;
}

/* =====================================================================
   Design alignment with Products Management / Featured Products pages
   (same tokens: #e2e9f2 card border, 12px radius, 7px fields, #172b46 text)
   ===================================================================== */
:host {
  display: block;
  container-type: inline-size;
  color: #253750;
  font-size: 12px;
  --mdc-outlined-text-field-container-shape: 7px;
  --mdc-outlined-text-field-outline-color: #dce5ef;
  --mdc-outlined-text-field-hover-outline-color: color-mix(in srgb, var(--primary-color) 25%, white);
  --mdc-outlined-text-field-focus-outline-color: var(--primary-color);
  --mdc-outlined-text-field-label-text-color: #7d8a9d;
  --mdc-outlined-text-field-input-text-color: #253750;
  --mdc-outlined-text-field-disabled-input-text-color: #8491a3;
  --mdc-outlined-text-field-disabled-outline-color: #e2e9f2;
  --mat-form-field-container-text-size: 13px;
  --mat-select-trigger-text-size: 13px;
  --mdc-outlined-text-field-label-text-size: 12px;
}

.product-detail-container {
  margin-top: 20px;
}
.product-detail-container .note-container {
  font-size: 12px;
  color: #936300;
  background: #fff7e6;
  border: 1px solid #f3e2b8;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
}
.product-detail-container .form-container {
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
  padding: 24px;
}
.product-detail-container .product-input-wrap {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 0;
  align-items: start;
}
.product-detail-container .product-input-wrap .input-div {
  width: auto;
}
.product-detail-container .product-input-wrap .width-100 {
  grid-column: 1/-1;
  width: auto;
}
.product-detail-container .product-input-wrap .form-inputs {
  padding-bottom: 16px;
  min-width: 0;
}
.product-detail-container .product-input-wrap .form-inputs mat-form-field {
  width: 100%;
}
.product-detail-container .product-input-wrap .checkbox-wrap {
  padding-top: 8px;
  border-top: 1px solid #edf1f6;
}
.product-detail-container .product-input-wrap .checkbox-wrap .title3 {
  color: #172b46;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
  margin: 10px 0 10px;
  text-transform: none;
}
.product-detail-container .product-input-wrap .checkbox-wrap .d-flex {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.product-detail-container .product-input-wrap .checkbox-wrap .border_class {
  width: auto;
  height: 44px;
  padding: 0 14px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.15s, background 0.15s;
}
.product-detail-container .product-input-wrap .checkbox-wrap .border_class:hover {
  border-color: color-mix(in srgb, var(--primary-color) 25%, white);
  background: color-mix(in srgb, var(--primary-color) 4%, white);
}
.product-detail-container .product-input-wrap .checkbox-wrap .label2 {
  font-size: 12px;
  color: #53647a;
}
.product-detail-container .product-input-wrap .checkbox-wrap .radio-div {
  padding: 8px;
  border-color: #c9d4e2;
}
.product-detail-container .product-input-wrap .checkbox-wrap .radio-size {
  height: 18px;
  width: 18px;
}
.product-detail-container .product-input-wrap .checkbox-wrap .radio-checked {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--primary-color);
}
.product-detail-container .product-input-wrap .checkbox-wrap .radio-checked::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 3px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.product-detail-container .product-input-wrap .checkbox-wrap .border_class:has(.radio-checked) {
  border-color: color-mix(in srgb, var(--primary-color) 45%, white);
  background: color-mix(in srgb, var(--primary-color) 5%, white);
}
.product-detail-container .product-input-wrap .checkbox-wrap .border_class:has(.radio-checked) .label2 {
  color: var(--primary-font-color, #172b46);
  font-weight: 500;
}
.product-detail-container .product-input-wrap .checkbox-wrap .radio-checked.mr-15,
.product-detail-container .product-input-wrap .checkbox-wrap .radio-div.mr-15,
.product-detail-container .product-input-wrap .checkbox-wrap .radio-size.mr-15 {
  margin: 0 !important;
  margin-inline-end: 10px !important;
  flex-shrink: 0;
}
.product-detail-container .img-wrap h2,
.product-detail-container .upload-heading,
.product-detail-container .title3 {
  color: #172b46;
  font-size: 13px !important;
  line-height: 20px;
  font-weight: 600;
  text-transform: none;
  align-items: center;
}
.product-detail-container .img-wrap {
  padding-top: 8px;
  border-top: 1px solid #edf1f6;
  margin-top: 8px;
}
.product-detail-container .img-wrap .uploaded-image-container {
  column-gap: 14px;
  row-gap: 14px;
}
.product-detail-container .img-wrap .uploaded-image-container .image-card {
  width: 160px;
  height: 160px;
  min-height: 160px;
  max-height: 160px;
  border: 1px solid #e2e9f2;
  border-radius: 10px;
  background: #f7f9fc;
  overflow: hidden;
}
.product-detail-container .img-wrap .uploaded-image-container .image-card .preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.product-detail-container .img-wrap .uploaded-image-container .image-card .icon-wrap div {
  box-shadow: 0 2px 8px rgba(23, 43, 70, 0.15);
}
.product-detail-container .img-wrap .uploaded-image-container .upload-wrap {
  border: 1px dashed #c9d4e2;
  padding: 8px;
}
.product-detail-container .img-wrap .uploaded-image-container .upload-wrap div {
  background: #f7f9fc;
  border-radius: 7px;
}
.product-detail-container .error-msg {
  display: block;
  color: #c34242;
  font-size: 11px;
  line-height: 16px;
  margin-top: 4px;
  text-align: start;
}
.product-detail-container button[mat-flat-button] {
  --mdc-filled-button-container-shape: 8px;
  --mdc-filled-button-container-height: 36px;
  --mdc-filled-button-container-color: var(--primary-color);
  --mdc-filled-button-label-text-color: #fff;
  --mdc-filled-button-label-text-size: 12px;
  box-shadow: none;
}
.product-detail-container .mat-accordion {
  display: block;
  margin: 8px 0 16px;
}
.product-detail-container .mat-accordion .mat-expansion-panel {
  border: 1px solid #e2e9f2;
  border-radius: 12px !important;
  box-shadow: none !important;
  margin-bottom: 10px;
  overflow: hidden;
}
.product-detail-container .mat-accordion .accordian-label {
  color: #172b46;
  font-size: 13px;
  font-weight: 600;
}
.product-detail-container .relatedProduct {
  background-color: transparent;
  padding-top: 8px;
  padding-bottom: 8px;
}
.product-detail-container .relatedProduct .w-40 {
  width: auto !important;
}
.product-detail-container .relatedProduct .product-input-wrap {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
}
.product-detail-container .relatedProduct .space-between,
.product-detail-container .relatedProduct .related_list {
  background-color: transparent;
}
.product-detail-container .document-upload-container {
  border: 0;
  padding: 4px 0 0 !important;
}
.product-detail-container .listing-table {
  border: 1px solid #e2e9f2;
  border-radius: 10px;
  padding: 0;
  margin-bottom: 12px;
}
.product-detail-container .listing-table .table {
  border-collapse: collapse;
}
.product-detail-container .listing-table .table .column-heading {
  background: #fbfcfe;
  color: #7d8a9d;
  font-size: 10px;
  font-weight: 500;
  text-transform: none;
  padding: 12px 16px;
  border-bottom: 1px solid #edf1f6;
  white-space: nowrap;
}
.product-detail-container .listing-table .table .table-body .table-row {
  border-bottom: 1px solid #edf1f6;
}
.product-detail-container .listing-table .table .table-body .table-row:last-child {
  border-bottom: 0;
}
.product-detail-container .listing-table .table .table-body .table-row:hover {
  background: #fcfdff;
}
.product-detail-container .listing-table .table .table-body .table-row td {
  font-size: 11px;
  line-height: 18px;
  color: #253750;
  padding: 12px 16px;
}
.product-detail-container .tag-cover-box {
  border: 1px solid #dce5ef;
  border-radius: 7px;
  min-height: 52px;
}
.product-detail-container .tag-cover-box .grey-box {
  background: #f1f6fd;
  border: 0;
  border-radius: 20px;
  color: #3d5a80;
  font-size: 11px;
  margin: 8px 6px;
}
.product-detail-container .product-bottom-container {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #edf1f6;
}
.product-detail-container .product-bottom-container .next-button {
  min-width: 110px;
}

.custom-dropdown-icon {
  position: relative;
}
.custom-dropdown-icon .select-label-text {
  position: absolute;
  top: -7px;
  inset-inline-start: 10px;
  z-index: 2;
  width: auto !important;
  height: auto !important;
  max-width: calc(100% - 24px);
  margin: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  white-space: nowrap;
  padding: 0 4px !important;
  background: #fff;
  color: #7d8a9d !important;
  font-size: 11px !important;
  line-height: 14px;
  text-transform: none !important;
}
.custom-dropdown-icon .select-label-text .pl-10 {
  padding: 0;
}
.custom-dropdown-icon .select-label-text .required-text {
  color: inherit;
}
.custom-dropdown-icon ng-select {
  top: 0 !important;
  margin: 0 !important;
}
.custom-dropdown-icon ::ng-deep .ng-select .ng-select-container {
  margin-top: 0 !important;
  min-height: 41px !important;
  height: 41px !important;
  border: 1px solid #dce5ef !important;
  border-radius: 7px !important;
  background: #fff;
  box-shadow: none !important;
  color: #253750;
  font-size: 13px;
}
.custom-dropdown-icon ::ng-deep .ng-select.ng-select-focused .ng-select-container {
  border-color: var(--primary-color) !important;
}
.custom-dropdown-icon ::ng-deep .ng-select.ng-select-disabled .ng-select-container {
  background: #fff;
  border-color: #e2e9f2 !important;
}
.custom-dropdown-icon ::ng-deep .ng-select.ng-select-disabled .ng-select-container .ng-value-label {
  color: #8491a3;
}
.custom-dropdown-icon ::ng-deep .ng-select .ng-value-container {
  padding-inline-start: 15px !important;
}

.custom-dropdown-icon:has(.error-msg) .select-label-text,
.custom-dropdown-icon:has(.error-msg) .select-label-text span {
  color: #c34242 !important;
}
.custom-dropdown-icon:has(.error-msg) ::ng-deep .ng-select .ng-select-container {
  border-color: #c34242 !important;
}

.product-detail-container .form-container > form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  align-items: start;
}
.product-detail-container .form-container > form > * {
  grid-column: 1/-1;
  min-width: 0;
}
.product-detail-container .form-container > form > .product-input-wrap {
  display: contents;
}
.product-detail-container .form-container > form > .product-input-wrap > .form-inputs {
  grid-column: auto;
}
.product-detail-container .form-container > form > .product-input-wrap > .width-100 {
  grid-column: 1/-1;
}
.product-detail-container .form-container > form > .editTag-ltr,
.product-detail-container .form-container > form > .editTag-rtl,
.product-detail-container .form-container > form > .saveRelated {
  float: none;
  display: flex;
  justify-content: flex-end;
  height: auto;
  margin: 0;
  padding-bottom: 0;
}
.product-detail-container .form-container > form > .editTag-ltr .form-inputs,
.product-detail-container .form-container > form > .editTag-rtl .form-inputs,
.product-detail-container .form-container > form > .saveRelated .form-inputs {
  padding-bottom: 12px;
}
.product-detail-container .form-container > form > .editTag-ltr .form-inputs:empty,
.product-detail-container .form-container > form > .editTag-rtl .form-inputs:empty,
.product-detail-container .form-container > form > .saveRelated .form-inputs:empty {
  display: none;
}
.product-detail-container .form-container > form > .editTag-ltr:not(:has(button)),
.product-detail-container .form-container > form > .editTag-rtl:not(:has(button)),
.product-detail-container .form-container > form > .saveRelated:not(:has(button)) {
  display: none;
}

.product-detail-container mat-accordion.relatedProduct {
  padding: 0 !important;
  margin: 4px 0 12px !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}
.product-detail-container mat-accordion.relatedProduct::before, .product-detail-container mat-accordion.relatedProduct::after {
  display: none !important;
}

.product-detail-container .img-wrap .loader-style {
  display: none;
}

.product-detail-container .relatedProduct .listing-table:not(:has(table)) {
  border: 0;
  overflow: visible;
  max-height: none;
  margin-bottom: 0;
  padding: 0;
}

.product-detail-container .relatedProduct .loader-style {
  border: 1px dashed #dce5ef;
  border-radius: 10px;
  padding: 28px 12px;
  text-align: center;
  color: #8491a3;
  font-size: 11px;
  min-height: 0 !important;
  height: auto !important;
}

.product-detail-container ::ng-deep .mat-mdc-form-field .mdc-floating-label,
.product-detail-container ::ng-deep .mat-mdc-form-field mat-label,
.product-detail-container .select-label-text {
  text-transform: uppercase !important;
  letter-spacing: 0.3px;
}

.addTag-Btn-ltr,
.addTag-Btn-rtl {
  top: 3px !important;
  --mdc-filled-button-container-height: 35px !important;
}

.addTag-Btn-ltr {
  right: 3px !important;
}

.addTag-Btn-rtl {
  left: 3px !important;
}

.product-detail-container .tag-cover-box {
  min-height: 41px;
  align-items: center;
}

:host {
  --pd-ink: var(--primary-font-color, #172b46);
  --pd-text: var(--primary-font-color, #253750);
  --pd-muted: var(--secondary-grey-color, #7d8a9d);
  --pd-border: color-mix(in srgb, var(--grey-border, #D5D7DA) 70%, white);
  --pd-divider: color-mix(in srgb, var(--grey-border, #D5D7DA) 45%, white);
  --pd-soft: color-mix(in srgb, var(--primary-color) 4%, white);
  color: var(--pd-text);
  --mdc-outlined-text-field-outline-color: var(--pd-border);
  --mdc-outlined-text-field-label-text-color: var(--pd-muted);
  --mdc-outlined-text-field-input-text-color: var(--pd-text);
  --mdc-outlined-text-field-disabled-outline-color: var(--pd-divider);
}

.product-detail-container .form-container,
.product-detail-container .listing-table,
.product-detail-container .mat-accordion .mat-expansion-panel,
.product-detail-container .img-wrap .uploaded-image-container .image-card {
  border-color: var(--pd-border);
}
.product-detail-container .img-wrap,
.product-detail-container .product-input-wrap .checkbox-wrap,
.product-detail-container .product-bottom-container,
.product-detail-container .listing-table .table .column-heading,
.product-detail-container .listing-table .table .table-body .table-row {
  border-color: var(--pd-divider);
}
.product-detail-container .product-input-wrap .checkbox-wrap .border_class,
.product-detail-container .tag-cover-box,
.product-detail-container .relatedProduct .loader-style,
.product-detail-container .img-wrap .uploaded-image-container .upload-wrap {
  border-color: var(--pd-border);
}
.product-detail-container .img-wrap h2,
.product-detail-container .upload-heading,
.product-detail-container .title3,
.product-detail-container .product-input-wrap .checkbox-wrap .title3,
.product-detail-container .mat-accordion .accordian-label,
.product-detail-container .listing-table .table .table-body .table-row td {
  color: var(--pd-ink);
}
.product-detail-container .product-input-wrap .checkbox-wrap .label2,
.product-detail-container .listing-table .table .column-heading,
.product-detail-container .relatedProduct .loader-style {
  color: var(--pd-muted);
}
.product-detail-container .tag-cover-box .grey-box {
  background: color-mix(in srgb, var(--primary-color) 8%, white);
  color: color-mix(in srgb, var(--primary-color) 70%, black);
}
.product-detail-container .img-wrap .uploaded-image-container .image-card,
.product-detail-container .img-wrap .uploaded-image-container .upload-wrap div,
.product-detail-container .listing-table .table .column-heading {
  background: var(--pd-soft);
}

.custom-dropdown-icon .select-label-text,
.custom-dropdown-icon .select-label-text span {
  color: var(--pd-muted) !important;
}
.custom-dropdown-icon ::ng-deep .ng-select .ng-value .ng-value-label,
.custom-dropdown-icon ::ng-deep .ng-select .ng-value span {
  color: var(--pd-text) !important;
}
.custom-dropdown-icon ::ng-deep .ng-select.ng-select-disabled .ng-value .ng-value-label,
.custom-dropdown-icon ::ng-deep .ng-select.ng-select-disabled .ng-value span {
  color: var(--pd-muted) !important;
}
.custom-dropdown-icon ::ng-deep .ng-select .ng-select-container {
  border-color: var(--pd-border) !important;
  color: var(--pd-text);
}
.custom-dropdown-icon ::ng-deep .ng-select.ng-select-focused .ng-select-container {
  border-color: var(--primary-color) !important;
}

@media (max-width: 768px) {
  .product-detail-container .form-container {
    padding: 16px;
  }
  .product-detail-container .form-container > form,
  .product-detail-container .product-input-wrap,
  .product-detail-container .product-input-wrap .checkbox-wrap .d-flex,
  .product-detail-container .relatedProduct .product-input-wrap {
    grid-template-columns: minmax(0, 1fr);
  }
  .product-detail-container .relatedProduct .product-input-wrap {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .product-detail-container .relatedProduct .product-input-wrap > .form-inputs:first-child {
    grid-column: 1/-1;
  }
  .product-detail-container .relatedProduct .filters-icon {
    justify-content: flex-end;
    padding-bottom: 16px;
    align-self: center;
    gap: 6px;
  }
  .product-detail-container .form-container {
    border: 0;
    padding: 4px 0 0;
  }
  .product-detail-container .img-wrap .uploaded-image-container .image-card {
    width: 130px;
    height: 130px;
    min-height: 130px;
    max-height: 130px;
  }
}
@container (max-width: 640px) {
  .product-detail-container .form-container {
    padding: 16px;
  }
  .product-detail-container .form-container > form,
  .product-detail-container .product-input-wrap,
  .product-detail-container .product-input-wrap .checkbox-wrap .d-flex,
  .product-detail-container .relatedProduct .product-input-wrap {
    grid-template-columns: minmax(0, 1fr);
  }
  .product-detail-container .relatedProduct .product-input-wrap {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .product-detail-container .relatedProduct .product-input-wrap > .form-inputs:first-child {
    grid-column: 1/-1;
  }
  .product-detail-container .relatedProduct .filters-icon {
    justify-content: flex-end;
    padding-bottom: 16px;
    align-self: center;
    gap: 6px;
  }
  .product-detail-container .form-container {
    border: 0;
    padding: 4px 0 0;
  }
  .product-detail-container .img-wrap .uploaded-image-container .image-card {
    width: 130px;
    height: 130px;
    min-height: 130px;
    max-height: 130px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/product-editor.scss","webpack://./src/app/components/product-detail/product-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,0CAAA;EACA,oCAAA;ACCJ;;ADEA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,0BAAA;EACA,YAAA;ACCJ;;ADEA;;EAEI,gBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,WAAA;ACCJ;;ADEA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;ACCJ;;ADEA;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,eAAA;EACA,gBAAA;EACA,cAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;ACCJ;;ADEA;EACI,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,sBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,2BAAA;ACCJ;;ADEA;;EAEI,cAAA;ACCJ;;ADEA;EACI,yBAAA;EACA,WAAA;EACA,eAAA;ACCJ;;ADEA;;EAEI,aAAA;EACA,iBAAA;EACA,gCAAA;ACCJ;;ADEA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;ACCJ;;ADEA;;EAEI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;ACCJ;;ADEA;;EAEI,eAAA;EACA,iBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;ACCJ;;ADEA;EACI,aAAA;EACA,yBAAA;ACCJ;;ADEA;;EAEI,0BAAA;EACA,kBAAA;EACA,aAAA;ACCJ;;ADEA;EACI,aAAA;EACA,QAAA;EACA,eAAA;ACCJ;;ADEA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;ACCJ;;ADEA;EACI,cAAA;EACA,eAAA;ACCJ;;ADEA;EACI,aAAA;ACCJ;;ADEA;EACI;IACI,aAAA;ECCN;EDEE;IACI,gBAAA;ECAN;EDGE;IACI,SAAA;ECDN;AACF;AAlOC;EACC,oBAAA;AAoOF;AAjOC;EACC,aAAA;EACA,4BAAA;AAmOF;AAjOE;EACC,uBAAA;EACA,kBAAA;AAmOH;AAhOI;EACC,aAAA;AAkOL;AA5NI;;EACC,aAAA;AA+NL;AA3NG;EACC,4BAAA;EACA,kDAAA;EACA,oCAAA;EACA,qBAAA;EACA,6BAAA;AA6NJ;AAzNE;EACC,YAAA;AA2NH;AAxNE;EACC,WAAA;AA0NH;AAvNE;EACC,aAAA;EACA,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;AAyNH;AAvNG;EACC,0BAAA;EACA,gDAAA;EACA,+BAAA;AAyNJ;AAtNG;EACC,yBAAA;AAwNJ;AAnNG;EACC,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;EACA,0BAAA;AAqNJ;AAlNG;EACC,mBAAA;EACA,uCAAA;EACA,SAAA;AAoNJ;AAjNG;EACC,aAAA;EACA,8BAAA;AAmNJ;AAhNG;EACC,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AAkNJ;AA/MG;EACC,aAAA;EACA,mBAAA;AAiNJ;AA/MI;EACC,iBAAA;AAiNL;AA5MG;EACC,oCAAA;EACA,aAAA;EACA,mBAAA;AA8MJ;AA3MG;EACC,cAAA;EACA,aAAA;AA6MJ;AAvME;EACC,eAAA;EACA,qCAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;AAyMH;AAvMG;EACC,8BAAA;EACA,8BAAA;EACA,+BAAA;AAyMJ;AArME;EACC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAuMH;AArMG;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAuMJ;AArMI;EACC,mBAAA;AAuML;AApMI;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AAsML;AApMK;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAsMN;AAjMG;EACC,yBAAA;EACA,kBAAA;AAmMJ;AAjMI;EACC,mBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAmML;AAjMK;EACC,WAAA;EACA,YAAA;AAmMN;AAhMK;EACC,gBAAA;EACA,gBAAA;AAkMN;AA1LC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AA4LF;AA1LE;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AA4LH;AA1LG;EACC,gBAAA;AA4LJ;AAvLG;EACC,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAyLJ;;AA/KC;;EAEC,iBAAA;AAkLF;;AA9KA;EACC,yBAAA;AAiLD;;AA9KA;EACC,2BAAA;AAiLD;;AA9KA;EACC,uBAAA;EACA,eAAA;AAiLD;;AA9KA;EACC,sBAAA;AAiLD;;AA7KA;EACC,iCAAA;EACA,0BAAA;AAgLD;AA9KC;EACC,mBAAA;AAgLF;AA7KC;EACC,uBAAA;AA+KF;AA5KC;EACC,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AA8KF;;AA1KA;EACC,kBAAA;EACA,gBAAA;AA6KD;;AA1KA;EACC,aAAA;EACA,yBAAA;EACA,mBAAA;AA6KD;;AA1KA;EACC,aAAA;EACA,8BAAA;AA6KD;;AA1KA;EACC,oBAAA;EACA,cAAA;AA6KD;AA3KC;EACC,WAAA;AA6KF;AA3KE;EACC,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;AA6KH;AAzKG;EACC,kBAAA;AA2KJ;AAtKG;EACC,wDAAA;AAwKJ;AAtKI;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,sBAAA;AAwKL;AAtKK;EACC,kBAAA;AAwKN;AApKI;EACC,aAAA;EACA,mBAAA;AAsKL;AAnKI;EACC,aAAA;AAqKL;AAnKK;EACC,eAAA;AAqKN;AAlKK;EACC,mBAAA;AAoKN;;AA3JA;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,eAAA;AA8JD;AA5JC;EACC,gBAAA;AA8JF;;AA1JA;EACC,WAAA;AA6JD;;AA1JA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;AA6JD;;AA1JA;EACC,iBAAA;EACA,iBAAA;AA6JD;;AA1JA;EACC,yBAAA;AA6JD;;AA1JA;EACC,0BAAA;AA6JD;;AA1JA;EACC,kBAAA;EACA,iBAAA;AA6JD;;AA1JA;EACC,eAAA;EACA,sBAAA;AA6JD;;AA1JA;EACC,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AA6JD;;AA1JA;EACC,mBAAA;AA6JD;;AA1JA;EACC,eAAA;AA6JD;;AA1JA;EACC,eAAA;EACA,uBAAA;AA6JD;;AA1JA;EACC,aAAA;AA6JD;AA3JC;EACC,qBAAA;AA6JF;;AAzJA;EACC,kBAAA;AA4JD;AA1JC;EACC,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;EACA,4BAAA;AA4JF;;AAxJA;EACC,sBAAA;EACA,mBAAA;AA2JD;;AAxJA;EACC,+BAAA;AA2JD;;AAxJA;EASC,mBAAA;EACA,oBAAA;EACA,0CAAA;AAmJD;AA7JC;EACC,YAAA;AA+JF;AA5JC;EACC,qBAAA;AA8JF;AAvJC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAyJF;AAvJE;EACC,kBAAA;EACA,qBAAA;AAyJH;AArJC;EACC,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,0CAAA;AAuJF;AArJE;EACC,iBAAA;EACA,qCAAA;EACA,iBAAA;EACA,0BAAA;AAuJH;AArJG;EACC,kBAAA;AAuJJ;AAlJC;EACC,aAAA;EACA,kBAAA;AAoJF;AAlJE;EACC,sBAAA;AAoJH;AAjJE;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAmJH;AAhJE;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,+BAAA;AAkJH;AA/IE;EACC,gDAAA;AAiJH;AA7IC;EACC,iBAAA;EACA,0CAAA;AA+IF;AA5IC;EACC,wCAAA;EACA,mBAAA;AA8IF;AA3IC;EACC,eAAA;EACA,qCAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;AA6IF;AA3IE;EACC,8BAAA;EACA,8BAAA;EACA,+BAAA;AA6IH;;AAxIA;EACC,WAAA;EACA,YAAA;AA2ID;;AAxIA;EACC,YAAA;AA2ID;;AAxIA;EACC,YAAA;EACA,8BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qCAAA;AA2ID;AAzIC;EACC,iBAAA;AA2IF;;AAvIA;EACC,kCAAA;AA0ID;;AAvIA;EACC,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AA0ID;AAxIC;EACC,kBAAA;EACA,UAAA;EACA,0CAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AA0IF;AAxIE;EACC,mBAAA;AA0IH;AAvIE;EACC,YAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;AAyIH;;AApIA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AAuID;;AApIA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AAuID;;AApIA;EACC,YAAA;EACA,iBAAA;AAuID;;AApIA;EACC,WAAA;AAuID;;AApIA;EAEE;IACC,qBAAA;EAsID;AACF;AAlIA;EACC,YAAA;EACA,oBAAA;AAoID;;AAjIA;EACC,WAAA;EACA,oBAAA;AAoID;;AAjIA;;;0EAAA;AAIA;EACC,cAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,8CAAA;EACA,gDAAA;EACA,kGAAA;EACA,mEAAA;EACA,mDAAA;EACA,mDAAA;EACA,4DAAA;EACA,yDAAA;EACA,0CAAA;EACA,oCAAA;EACA,+CAAA;AAoID;;AAjIA;EACC,gBAAA;AAoID;AAlIC;EACC,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAoIF;AAhIC;EACC,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAkIF;AA9HC;EACC,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAgIF;AA9HE;EACC,WAAA;AAgIH;AA7HE;EACC,iBAAA;EACA,WAAA;AA+HH;AA5HE;EACC,oBAAA;EACA,YAAA;AA8HH;AA5HG;EACC,WAAA;AA8HJ;AAzHE;EACC,gBAAA;EACA,6BAAA;AA2HH;AAzHG;EACC,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AA2HJ;AAxHG;EACC,aAAA;EACA,gDAAA;EACA,SAAA;AA0HJ;AAvHG;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AAyHJ;AAvHI;EACC,iEAAA;EACA,8DAAA;AAyHL;AArHG;EACC,eAAA;EACA,cAAA;AAuHJ;AApHG;EACC,YAAA;EACA,qBAAA;AAsHJ;AAnHG;EACC,YAAA;EACA,WAAA;AAqHJ;AAhHG;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;AAkHJ;AAhHI;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;AAkHL;AA9GG;EACC,iEAAA;EACA,8DAAA;AAgHJ;AA9GI;EACC,yCAAA;EACA,gBAAA;AAgHL;AA5GG;;;EAGC,oBAAA;EACA,kCAAA;EACA,cAAA;AA8GJ;AAxGC;;;EAGC,cAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AA0GF;AAvGC;EACC,gBAAA;EACA,6BAAA;EACA,eAAA;AAyGF;AAvGE;EACC,gBAAA;EACA,aAAA;AAyGH;AAvGG;EACC,YAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAyGJ;AAvGI;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAyGL;AAtGI;EACC,4CAAA;AAwGL;AApGG;EACC,0BAAA;EACA,YAAA;AAsGJ;AApGI;EACC,mBAAA;EACA,kBAAA;AAsGL;AA/FC;EACC,cAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAiGF;AA7FC;EACC,wCAAA;EACA,0CAAA;EACA,yDAAA;EACA,0CAAA;EACA,yCAAA;EACA,gBAAA;AA+FF;AA3FC;EACC,cAAA;EACA,kBAAA;AA6FF;AA3FE;EACC,yBAAA;EACA,8BAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AA6FH;AA1FE;EACC,cAAA;EACA,eAAA;EACA,gBAAA;AA4FH;AAxFC;EACC,6BAAA;EACA,gBAAA;EACA,mBAAA;AA0FF;AAxFE;EACC,sBAAA;AA0FH;AAvFE;EACC,yDAAA;AAyFH;AAtFE;;EAEC,6BAAA;AAwFH;AApFC;EACC,SAAA;EACA,2BAAA;AAsFF;AAlFC;EACC,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;AAoFF;AAlFE;EACC,yBAAA;AAoFH;AAlFG;EACC,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AAoFJ;AAjFG;EACC,gCAAA;AAmFJ;AAjFI;EACC,gBAAA;AAmFL;AAhFI;EACC,mBAAA;AAkFL;AA/EI;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAiFL;AA1EC;EACC,yBAAA;EACA,kBAAA;EACA,gBAAA;AA4EF;AA1EE;EACC,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AA4EH;AAvEC;EACC,gBAAA;EACA,iBAAA;EACA,6BAAA;AAyEF;AAvEE;EACC,gBAAA;AAyEH;;AAnEA;EACC,kBAAA;AAsED;AApEC;EACC,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;EACA,+BAAA;AAsEF;AApEE;EACC,UAAA;AAsEH;AAnEE;EACC,cAAA;AAqEH;AAjEC;EACC,iBAAA;EACA,oBAAA;AAmEF;AA/DE;EACC,wBAAA;EACA,2BAAA;EACA,uBAAA;EACA,oCAAA;EACA,6BAAA;EACA,gBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AAiEH;AA9DE;EACC,6CAAA;AAgEH;AA7DE;EACC,gBAAA;EACA,gCAAA;AA+DH;AA7DG;EACC,cAAA;AA+DJ;AA3DE;EACC,qCAAA;AA6DH;;AArDC;;EAEC,yBAAA;AAwDF;AArDC;EACC,gCAAA;AAuDF;;AA/CA;EACC,aAAA;EACA,gDAAA;EACA,gBAAA;EACA,kBAAA;AAkDD;AAhDC;EACC,iBAAA;EACA,YAAA;AAkDF;AA/CC;EACC,iBAAA;AAiDF;AA/CE;EACC,iBAAA;AAiDH;AA9CE;EACC,iBAAA;AAgDH;AA3CC;;;EAGC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;AA6CF;AA3CE;;;EACC,oBAAA;AA+CH;AA7CG;;;EACC,aAAA;AAiDJ;AA7CE;;;EACC,aAAA;AAiDH;;AA1CA;EACC,qBAAA;EACA,6BAAA;EACA,kCAAA;EACA,oBAAA;EACA,2BAAA;AA6CD;AA3CC;EAEC,wBAAA;AA4CF;;AAvCA;EACC,aAAA;AA0CD;;AAtCA;EACC,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAyCD;;AArCA;EACC,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,uBAAA;AAwCD;;AAnCC;;;EAGC,oCAAA;EACA,qBAAA;AAsCF;;AAjCA;;EAEC,mBAAA;EACA,qDAAA;AAoCD;;AAjCA;EACC,qBAAA;AAoCD;;AAjCA;EACC,oBAAA;AAoCD;;AAjCA;EACC,gBAAA;EACA,mBAAA;AAoCD;;AA5BA;EACC,4CAAA;EACA,6CAAA;EACA,gDAAA;EACA,uEAAA;EACA,wEAAA;EACA,6DAAA;EAEA,qBAAA;EACA,yDAAA;EACA,2DAAA;EACA,0DAAA;EACA,mEAAA;AA8BD;;AA1BC;;;;EAIC,8BAAA;AA6BF;AA1BC;;;;;EAKC,+BAAA;AA4BF;AAzBC;;;;EAIC,8BAAA;AA2BF;AAxBC;;;;;;EAMC,oBAAA;AA0BF;AAvBC;;;EAGC,sBAAA;AAyBF;AAtBC;EACC,8DAAA;EACA,0DAAA;AAwBF;AArBC;;;EAGC,0BAAA;AAuBF;;AAlBC;;EAEC,iCAAA;AAqBF;AAjBC;;EAEC,gCAAA;AAmBF;AAhBC;;EAEC,iCAAA;AAkBF;AAfC;EACC,yCAAA;EACA,qBAAA;AAiBF;AAdC;EACC,6CAAA;AAgBF;;AAiCA;EA1CE;IACC,aAAA;EAaD;EAVA;;;;IAIC,qCAAA;EAYD;EARA;IACC,0CAAA;EAUD;EARC;IACC,iBAAA;EAUF;EANA;IACC,yBAAA;IACA,oBAAA;IACA,kBAAA;IACA,QAAA;EAQD;EAJA;IACC,SAAA;IACA,gBAAA;EAMD;EAHA;IACC,YAAA;IACA,aAAA;IACA,iBAAA;IACA,iBAAA;EAKD;AACF;AAGA;EA9CE;IACC,aAAA;EA8CD;EA3CA;;;;IAIC,qCAAA;EA6CD;EAzCA;IACC,0CAAA;EA2CD;EAzCC;IACC,iBAAA;EA2CF;EAvCA;IACC,yBAAA;IACA,oBAAA;IACA,kBAAA;IACA,QAAA;EAyCD;EArCA;IACC,SAAA;IACA,gBAAA;EAuCD;EApCA;IACC,YAAA;IACA,aAAA;IACA,iBAAA;IACA,iBAAA;EAsCD;AACF","sourcesContent":[":host {\n    display: block;\n    color: #253750;\n    font-size: 12px;\n    --mat-form-field-container-text-size: 12px;\n    --mat-select-trigger-text-size: 12px;\n}\n\n.form-container {\n    padding: 24px;\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: white;\n}\n\n.product-input-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 18px;\n    margin-bottom: 18px;\n}\n\n.form-inputs {\n    flex: 1 1 calc(50% - 18px);\n    min-width: 0;\n}\n\n.width-100,\n.w-100 {\n    flex-basis: 100%;\n}\n\nmat-form-field {\n    display: block;\n    width: 100%;\n}\n\n.field-display {\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.field-display>span:first-child {\n    display: block;\n    color: #7d8a9d;\n    margin-bottom: 8px;\n}\n\n.error-msg {\n    display: block;\n    color: #d92d20;\n    font-size: 11px;\n    margin-top: 6px;\n}\n\n.select-label-text {\n    display: block;\n    font-size: 11px;\n    color: #53647a;\n    margin-bottom: 6px;\n}\n\n.title3,\n.title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #172b46;\n}\n\n.note-container {\n    padding: 12px 16px;\n    background: #fff8e6;\n    border-radius: 8px;\n    margin-bottom: 16px;\n}\n\nmat-accordion {\n    display: block;\n    margin: 20px 0;\n}\n\nmat-expansion-panel {\n    box-shadow: none !important;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px !important;\n    margin-bottom: 12px;\n}\n\n.product-bottom-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding-top: 20px;\n    margin-top: 24px;\n    border-top: 1px solid #edf1f6;\n}\n\n.product-bottom-container mat-spinner {\n    display: inline-block;\n    margin-inline-end: 8px;\n}\n\n.prev {\n    cursor: pointer;\n    color: var(--primary-color);\n}\n\n.listing-table,\n.table-scroll {\n    overflow: auto;\n}\n\ntable {\n    border-collapse: collapse;\n    width: 100%;\n    font-size: 12px;\n}\n\nth,\ntd {\n    padding: 12px;\n    text-align: start;\n    border-bottom: 1px solid #edf1f6;\n}\n\nth {\n    background: #f8fafd;\n    color: #7d8a9d;\n    font-weight: 500;\n}\n\n.preview-image,\n.related-preview-img {\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n    border-radius: 8px;\n}\n\n.image-container,\n.variation-image {\n    display: inline-flex;\n    max-width: 160px;\n    padding: 8px;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    margin: 4px;\n}\n\n.image-container img,\n.variation-image img {\n    max-width: 100%;\n    max-height: 140px;\n    object-fit: contain;\n}\n\n.image-section {\n    padding: 16px;\n    background: #f8fafd;\n    border-radius: 8px;\n}\n\n.checkbox-wrap,\n.sku-check {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    align-items: center;\n}\n\n.checkbox-content {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n}\n\n.product-button {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.image-upload-container,\n.file-upload-container {\n    border: 1px dashed #dce5ef;\n    border-radius: 8px;\n    padding: 20px;\n}\n\n.tag-cover-box {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.grey-box {\n    padding: 6px 10px;\n    background: #f1f6fd;\n    border-radius: 6px;\n}\n\n.price-group-summary {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n    padding: 16px 0;\n}\n\ndt {\n    color: #7d8a9d;\n    font-size: 11px;\n}\n\ndd {\n    margin: 6px 0;\n}\n\n@media(max-width:650px) {\n    .form-container {\n        padding: 16px;\n    }\n\n    .form-inputs {\n        flex-basis: 100%;\n    }\n\n    .product-input-wrap {\n        gap: 14px;\n    }\n}","@import '../../../theme/product-editor';\n\n.product-detail-container {\n\t.form-container {\n\t\tpadding: 1.5625rem 0;\n\t}\n\n\t.product-input-wrap {\n\t\tdisplay: flex;\n\t\tplace-content: space-between;\n\n\t\t.form-inputs {\n\t\t\tpadding-bottom: 0.75rem;\n\t\t\tposition: relative;\n\n\t\t\tion-item {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-item.item-has-value,\n\t\t\tion-item.item-has-focus {\n\t\t\t\t.country-code {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tion-label {\n\t\t\t\tletter-spacing: 0 !important;\n\t\t\t\tcolor: var(--ion-color-secondary-black) !important;\n\t\t\t\ttext-transform: uppercase !important;\n\t\t\t\topacity: 1 !important;\n\t\t\t\tfont-size: 0.75rem !important;\n\t\t\t}\n\t\t}\n\n\t\t.input-div {\n\t\t\twidth: 49.2%;\n\t\t}\n\n\t\t.width-100 {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.sku-check {\n\t\t\tdisplay: flex;\n\t\t\tpadding: 0.625rem 0 0;\n\t\t\twidth: 60px;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\n\t\t\tion-label {\n\t\t\t\tfont-size: 1rem !important;\n\t\t\t\tcolor: var(--ion-color-primary-black) !important;\n\t\t\t\ttext-transform: none !important;\n\t\t\t}\n\n\t\t\tion-checkbox::part(container) {\n\t\t\t\tborder: 1px solid #D5DADC;\n\t\t\t}\n\t\t}\n\n\t\t.checkbox-wrap {\n\t\t\t.title3 {\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\tmargin: 0.5rem 0 0.625rem;\n\t\t\t\ttext-transform: capitalize;\n\t\t\t}\n\n\t\t\t.label2 {\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t.d-flex {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t}\n\n\t\t\t.border_class {\n\t\t\t\tborder: 1px solid var(--ion-divider);\n\t\t\t\tpadding: 0 1.25rem;\n\t\t\t\theight: 50px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\twidth: 49%;\n\t\t\t}\n\n\t\t\t.display-div {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.icon-holder {\n\t\t\t\t\tdisplay: contents;\n\t\t\t\t}\n\t\t\t}\n\n\n\t\t\t.radio-div {\n\t\t\t\tborder: 1px solid var(--ion-divider);\n\t\t\t\tpadding: 12px;\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\n\t\t\t.radio-size {\n\t\t\t\theight: 1.5rem;\n\t\t\t\twidth: 1.5rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t.img-wrap {\n\t\th2 {\n\t\t\tfont-size: 1rem;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\tfont-weight: bold;\n\t\t\tmargin-top: 0.3125rem;\n\t\t\tdisplay: flex;\n\t\t\tposition: relative;\n\t\t\ttext-transform: capitalize;\n\n\t\t\tion-text {\n\t\t\t\tfont-weight: normal !important;\n\t\t\t\tfont-size: 0.875rem !important;\n\t\t\t\ttext-transform: none !important;\n\t\t\t}\n\t\t}\n\n\t\t.uploaded-image-container {\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tcolumn-gap: 1.25rem;\n\t\t\trow-gap: 1.25rem;\n\n\t\t\t.image-card {\n\t\t\t\twidth: 224px;\n\t\t\t\theight: 224px;\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\n\t\t\t\t.preview-image {\n\t\t\t\t\tmax-height: inherit;\n\t\t\t\t}\n\n\t\t\t\t.icon-wrap {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 8%;\n\t\t\t\t\tbottom: 7%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\tdiv {\n\t\t\t\t\t\tbackground: #fff;\n\t\t\t\t\t\twidth: 1.875rem;\n\t\t\t\t\t\theight: 1.875rem;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.upload-wrap {\n\t\t\t\tborder: 1px solid #D5DADC;\n\t\t\t\tpadding: 0.9375rem;\n\n\t\t\t\tdiv {\n\t\t\t\t\tbackground: #F0F3F4;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\tion-button {\n\t\t\t\t\t\twidth: 90px;\n\t\t\t\t\t\theight: 38px;\n\t\t\t\t\t}\n\n\t\t\t\t\tion-button::part(native) {\n\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\t}\n\n\t.product-bottom-container {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\tpadding-top: 1.125rem;\n\n\t\t.cancel {\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 0.9375rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tletter-spacing: 0.4px;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\tpadding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\n\t\t.product-button {\n\t\t\tion-button {\n\t\t\t\t--background: var(--ion-color-primary);\n\t\t\t\twidth: 100px;\n\t\t\t\theight: 46px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 0.9375rem;\n\t\t\t\tline-height: 1.125rem;\n\t\t\t\tletter-spacing: 0.4px;\n\t\t\t\t--box-shadow: none;\n\t\t\t\t--border-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n// Arabic inputs: only the typed text is RTL (input has dir=\"rtl\").\n// Do NOT set direction on the wrapper - it breaks the mat outline notch.\n.arabic-class {\n\ttextarea,\n\tinput {\n\t\ttext-align: right;\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.calendar-icon {\n\tmargin: auto !important;\n\tcursor: pointer;\n}\n\nng-select {\n\twidth: 100% !important;\n\n}\n\n.custom-dd-tags {\n\tbackground: var(--ion-light-grey);\n\tpadding: 0.125rem 0.625rem;\n\n\t.custom-tags-label {\n\t\tfont-size: 0.875rem;\n\t}\n\n\timg {\n\t\tmargin: auto !important;\n\t}\n\n\t.color-thumbnail {\n\t\theight: 1.1875rem;\n\t\twidth: 1.1875rem;\n\t\tdisplay: inline-block;\n\t\tvertical-align: sub;\n\t}\n}\n\n.selected-options-container {\n\tposition: absolute;\n\tbottom: 0.375rem;\n}\n\n.add-warehouse-container {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n}\n\n.warehouse-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.listing-table {\n\tpadding: 0 0 1.25rem;\n\toverflow: auto;\n\n\t.table {\n\t\twidth: 100%;\n\n\t\t.column-heading {\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 0.975rem;\n\t\t\tline-height: 1rem;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-grey1);\n\t\t\tpadding: 0.5625rem 0.5625rem 0.5625rem 0;\n\t\t}\n\n\t\tthead {\n\t\t\tth:last-child {\n\t\t\t\tpadding: 0.5625rem;\n\t\t\t}\n\t\t}\n\n\t\t.table-body {\n\t\t\t.table-row {\n\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\ttd {\n\t\t\t\t\tpadding: 0.5625rem 0.5625rem 0.5625rem 0;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tline-height: 1.5rem;\n\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\t\tword-break: break-word;\n\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tpadding: 0.5625rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.right-arrow {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\n\t\t\t\t.toggle-edit-block {\n\t\t\t\t\tdisplay: flex;\n\n\t\t\t\t\t.edit-img-icon {\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t}\n\n\t\t\t\t\t.cursor-disabled {\n\t\t\t\t\t\tcursor: not-allowed;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\t}\n}\n\n.cancel {\n\tfont-weight: 400;\n\tfont-size: 0.9375rem;\n\tline-height: 1.125rem;\n\tletter-spacing: 0.4px;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-secondary-black);\n\tcursor: pointer;\n\n\t&:hover {\n\t\tfont-weight: 600;\n\t}\n}\n\n.warehouse-dd {\n\theight: 60%;\n}\n\n.file-input {\n\tposition: absolute;\n\twidth: 1px;\n\topacity: 0;\n}\n\n.image-container {\n\tmin-height: 224px;\n\tmax-height: 224px;\n}\n\n.document-upload-container {\n\tborder: 1px solid #D5DADC;\n}\n\n.accordian-label {\n\ttext-transform: capitalize;\n}\n\n.tooltip {\n\tposition: relative;\n\tdisplay: contents;\n}\n\n.remove-doc-icon {\n\tcursor: pointer;\n\tvertical-align: middle;\n}\n\n.tooltip .tooltiptext {\n\tvisibility: hidden;\n\tmax-width: 200px;\n\tmin-width: fit-content;\n\tbackground: #000;\n\tcolor: #fff;\n\ttext-align: center;\n\tborder-radius: 0.375rem;\n\tpadding: 0.125rem 0.5rem;\n\ttop: 3.5rem;\n\t/* Position the tooltip */\n\tposition: absolute;\n\tz-index: 1;\n}\n\n.tooltip:hover .tooltiptext {\n\tvisibility: visible;\n}\n\n.more-info-tooltip {\n\tmargin-top: 3px;\n}\n\n.note-container {\n\tfont-size: 1rem;\n\tcolor: var(--ion-grey1);\n}\n\n.uploaded-file-container {\n\tdisplay: flex;\n\n\t.tooltip {\n\t\tdisplay: inline-block;\n\t}\n}\n\n.uploaded-file {\n\tposition: relative;\n\n\t.uploaded-file-name {\n\t\tmax-width: 300px;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\t\tdisplay: -webkit-box !important;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t}\n}\n\n.info-rtl .more-info-tooltiptext {\n\tleft: unset !important;\n\tright: 0 !important;\n}\n\n.weight {\n\ttext-transform: none !important;\n}\n\n.relatedProduct {\n\t.h-50 {\n\t\theight: 50px;\n\t}\n\n\t.w-40 {\n\t\twidth: 44% !important;\n\t}\n\n\tpadding-top: 1.5rem;\n\tpadding-bottom: 2rem;\n\tbackground-color: var(--ion-color-gray-20);\n\n\t.filters-icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding-bottom: 0.75rem;\n\n\t\t.search-icon {\n\t\t\tmargin-top: 0.1rem;\n\t\t\tpadding-right: 0.5rem;\n\t\t}\n\t}\n\n\t.space-between {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding-bottom: 2rem;\n\t\tbackground-color: var(--ion-color-gray-20);\n\n\t\t.status-label {\n\t\t\tfont-size: 0.9rem;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\tfont-weight: bold;\n\t\t\ttext-transform: capitalize;\n\n\t\t\t.status-dropdown-div {\n\t\t\t\tmargin-top: 0.5rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t.filter-div {\n\t\tdisplay: flex;\n\t\tmargin-top: 0.5rem;\n\n\t\timg {\n\t\t\tmax-width: fit-content;\n\t\t}\n\n\t\t.filter-icon {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tpadding: 0 0.5625rem;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t.filter-label {\n\t\t\tcursor: pointer;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 0.875rem;\n\t\t\tline-height: 1.0625rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tletter-spacing: 0.3px;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\n\t\t.close-label {\n\t\t\tcolor: var(--ion-color-primary-black) !important;\n\t\t}\n\t}\n\n\t.related_list {\n\t\tmax-height: 280px;\n\t\tbackground-color: var(--ion-color-gray-20);\n\t}\n\n\t.iconColor {\n\t\tcolor: var(--ion-app-primary) !important;\n\t\tmargin-right: -40px;\n\t}\n\n\th2 {\n\t\tfont-size: 1rem;\n\t\tcolor: var(--ion-color-primary-black);\n\t\tfont-weight: bold;\n\t\tmargin-top: 0.3125rem;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t\ttext-transform: capitalize;\n\n\t\tion-text {\n\t\t\tfont-weight: normal !important;\n\t\t\tfont-size: 0.875rem !important;\n\t\t\ttext-transform: none !important;\n\t\t}\n\t}\n}\n\n.preview-image {\n\twidth: 50px;\n\theight: 50px;\n}\n\n.float-right {\n\tfloat: right;\n}\n\n.count {\n\theight: 50px;\n\tfont-weight: normal !important;\n\tfont-size: 0.875rem !important;\n\ttext-transform: none !important;\n\tcolor: var(--ion-color-primary-black);\n\n\tspan {\n\t\tfont-weight: bold;\n\t}\n}\n\n.justify-center {\n\tjustify-content: center !important;\n}\n\n.tag-cover-box {\n\tborder: 1px solid var(--ion-border-color);\n\tborder-radius: 5px;\n\toverflow: auto;\n\tflex-wrap: wrap;\n\tdisplay: flex;\n\tmax-height: 150px;\n\toverflow: auto;\n\n\t.grey-box {\n\t\tborder-radius: 5px;\n\t\topacity: 1;\n\t\tbackground: #2935470c;\n\t\twidth: fit-content;\n\t\theight: fit-content;\n\t\tpadding: 4px 10px 5px 10px;\n\t\tbackground: #f5f5f5;\n\t\tborder: 1px solid #f0f0f0;\n\t\talign-items: center;\n\t\tmargin: 10px;\n\t\tdisplay: inline;\n\t\tposition: relative;\n\n\t\tspan {\n\t\t\tpadding-right: 16px;\n\t\t}\n\n\t\t.close {\n\t\t\theight: 15px;\n\t\t\tposition: absolute;\n\t\t\tcursor: pointer;\n\t\t\ttop: 6px;\n\t\t\tright: -12px;\n\t\t}\n\t}\n}\n\n.addTag-Btn-ltr {\n\tposition: absolute;\n\ttop: 8px;\n\tz-index: 9;\n\tright: 7px;\n}\n\n.addTag-Btn-rtl {\n\tposition: absolute;\n\ttop: 8px;\n\tz-index: 9;\n\tleft: 7px;\n}\n\n.saveRelated {\n\theight: 50px;\n\tmargin-top: -20px;\n}\n\n.float-left {\n\tfloat: left;\n}\n\n@media screen and (max-width: 768px) {\n\t.relatedProduct {\n\t\t.w-40 {\n\t\t\twidth: 35% !important;\n\t\t}\n\t}\n}\n\n.editTag-ltr {\n\tfloat: right;\n\tpadding-bottom: 20px;\n}\n\n.editTag-rtl {\n\tfloat: left;\n\tpadding-bottom: 20px;\n}\n\n/* =====================================================================\n   Design alignment with Products Management / Featured Products pages\n   (same tokens: #e2e9f2 card border, 12px radius, 7px fields, #172b46 text)\n   ===================================================================== */\n:host {\n\tdisplay: block;\n\tcontainer-type: inline-size;\n\tcolor: #253750;\n\tfont-size: 12px;\n\t--mdc-outlined-text-field-container-shape: 7px;\n\t--mdc-outlined-text-field-outline-color: #dce5ef;\n\t--mdc-outlined-text-field-hover-outline-color: color-mix(in srgb, var(--primary-color) 25%, white);\n\t--mdc-outlined-text-field-focus-outline-color: var(--primary-color);\n\t--mdc-outlined-text-field-label-text-color: #7d8a9d;\n\t--mdc-outlined-text-field-input-text-color: #253750;\n\t--mdc-outlined-text-field-disabled-input-text-color: #8491a3;\n\t--mdc-outlined-text-field-disabled-outline-color: #e2e9f2;\n\t--mat-form-field-container-text-size: 13px;\n\t--mat-select-trigger-text-size: 13px;\n\t--mdc-outlined-text-field-label-text-size: 12px;\n}\n\n.product-detail-container {\n\tmargin-top: 20px;\n\n\t.note-container {\n\t\tfont-size: 12px;\n\t\tcolor: #936300;\n\t\tbackground: #fff7e6;\n\t\tborder: 1px solid #f3e2b8;\n\t\tborder-radius: 8px;\n\t\tpadding: 10px 14px;\n\t\tmargin-bottom: 16px;\n\t}\n\n\t// Form card - same look as .table-card on the list pages\n\t.form-container {\n\t\tborder: 1px solid #e2e9f2;\n\t\tborder-radius: 12px;\n\t\tbackground: #fff;\n\t\tpadding: 24px;\n\t}\n\n\t// Two-column responsive grid instead of 49.2% widths\n\t.product-input-wrap {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, minmax(0, 1fr));\n\t\tcolumn-gap: 16px;\n\t\trow-gap: 0;\n\t\talign-items: start;\n\n\t\t.input-div {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t.width-100 {\n\t\t\tgrid-column: 1 / -1;\n\t\t\twidth: auto;\n\t\t}\n\n\t\t.form-inputs {\n\t\t\tpadding-bottom: 16px;\n\t\t\tmin-width: 0;\n\n\t\t\tmat-form-field {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t// Choice groups (same name / image / price / weight / VAT / sample)\n\t\t.checkbox-wrap {\n\t\t\tpadding-top: 8px;\n\t\t\tborder-top: 1px solid #edf1f6;\n\n\t\t\t.title3 {\n\t\t\t\tcolor: #172b46;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tline-height: 20px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin: 10px 0 10px;\n\t\t\t\ttext-transform: none;\n\t\t\t}\n\n\t\t\t.d-flex {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: repeat(2, minmax(0, 1fr));\n\t\t\t\tgap: 12px;\n\t\t\t}\n\n\t\t\t.border_class {\n\t\t\t\twidth: auto;\n\t\t\t\theight: 44px;\n\t\t\t\tpadding: 0 14px;\n\t\t\t\tborder: 1px solid #dce5ef;\n\t\t\t\tborder-radius: 8px;\n\t\t\t\tbackground: #fff;\n\t\t\t\ttransition: border-color .15s, background .15s;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tborder-color: color-mix(in srgb, var(--primary-color) 25%, white);\n\t\t\t\t\tbackground: color-mix(in srgb, var(--primary-color) 4%, white);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.label2 {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tcolor: #53647a;\n\t\t\t}\n\n\t\t\t.radio-div {\n\t\t\t\tpadding: 8px;\n\t\t\t\tborder-color: #c9d4e2;\n\t\t\t}\n\n\t\t\t.radio-size {\n\t\t\t\theight: 18px;\n\t\t\t\twidth: 18px;\n\t\t\t}\n\n\t\t\t// Selected tick: drawn in CSS so it follows the configured primary colour\n\t\t\t// (assets/icon/check.svg hard-codes #0081ca)\n\t\t\t.radio-checked {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\twidth: 18px;\n\t\t\t\theight: 18px;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tbackground: var(--primary-color);\n\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 6px;\n\t\t\t\t\ttop: 3px;\n\t\t\t\t\twidth: 4px;\n\t\t\t\t\theight: 8px;\n\t\t\t\t\tborder: solid #fff;\n\t\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.border_class:has(.radio-checked) {\n\t\t\t\tborder-color: color-mix(in srgb, var(--primary-color) 45%, white);\n\t\t\t\tbackground: color-mix(in srgb, var(--primary-color) 5%, white);\n\n\t\t\t\t.label2 {\n\t\t\t\t\tcolor: var(--primary-font-color, #172b46);\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.radio-checked.mr-15,\n\t\t\t.radio-div.mr-15,\n\t\t\t.radio-size.mr-15 {\n\t\t\t\tmargin: 0 !important;\n\t\t\t\tmargin-inline-end: 10px !important;\n\t\t\t\tflex-shrink: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Section headings (images, documents, attributes)\n\t.img-wrap h2,\n\t.upload-heading,\n\t.title3 {\n\t\tcolor: #172b46;\n\t\tfont-size: 13px !important;\n\t\tline-height: 20px;\n\t\tfont-weight: 600;\n\t\ttext-transform: none;\n\t\talign-items: center;\n\t}\n\n\t.img-wrap {\n\t\tpadding-top: 8px;\n\t\tborder-top: 1px solid #edf1f6;\n\t\tmargin-top: 8px;\n\n\t\t.uploaded-image-container {\n\t\t\tcolumn-gap: 14px;\n\t\t\trow-gap: 14px;\n\n\t\t\t.image-card {\n\t\t\t\twidth: 160px;\n\t\t\t\theight: 160px;\n\t\t\t\tmin-height: 160px;\n\t\t\t\tmax-height: 160px;\n\t\t\t\tborder: 1px solid #e2e9f2;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\tbackground: #f7f9fc;\n\t\t\t\toverflow: hidden;\n\n\t\t\t\t.preview-image {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tobject-fit: contain;\n\t\t\t\t}\n\n\t\t\t\t.icon-wrap div {\n\t\t\t\t\tbox-shadow: 0 2px 8px rgba(23, 43, 70, .15);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.upload-wrap {\n\t\t\t\tborder: 1px dashed #c9d4e2;\n\t\t\t\tpadding: 8px;\n\n\t\t\t\tdiv {\n\t\t\t\t\tbackground: #f7f9fc;\n\t\t\t\t\tborder-radius: 7px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Inline validation like the list page filters\n\t.error-msg {\n\t\tdisplay: block;\n\t\tcolor: #c34242;\n\t\tfont-size: 11px;\n\t\tline-height: 16px;\n\t\tmargin-top: 4px;\n\t\ttext-align: start;\n\t}\n\n\t// Buttons - same as .button.primary on list pages\n\tbutton[mat-flat-button] {\n\t\t--mdc-filled-button-container-shape: 8px;\n\t\t--mdc-filled-button-container-height: 36px;\n\t\t--mdc-filled-button-container-color: var(--primary-color);\n\t\t--mdc-filled-button-label-text-color: #fff;\n\t\t--mdc-filled-button-label-text-size: 12px;\n\t\tbox-shadow: none;\n\t}\n\n\t// Accordions (related products / documents)\n\t.mat-accordion {\n\t\tdisplay: block;\n\t\tmargin: 8px 0 16px;\n\n\t\t.mat-expansion-panel {\n\t\t\tborder: 1px solid #e2e9f2;\n\t\t\tborder-radius: 12px !important;\n\t\t\tbox-shadow: none !important;\n\t\t\tmargin-bottom: 10px;\n\t\t\toverflow: hidden;\n\t\t}\n\n\t\t.accordian-label {\n\t\t\tcolor: #172b46;\n\t\t\tfont-size: 13px;\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.relatedProduct {\n\t\tbackground-color: transparent;\n\t\tpadding-top: 8px;\n\t\tpadding-bottom: 8px;\n\n\t\t.w-40 {\n\t\t\twidth: auto !important;\n\t\t}\n\n\t\t.product-input-wrap {\n\t\t\tgrid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;\n\t\t}\n\n\t\t.space-between,\n\t\t.related_list {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t.document-upload-container {\n\t\tborder: 0;\n\t\tpadding: 4px 0 0 !important;\n\t}\n\n\t// Tables - same as list pages\n\t.listing-table {\n\t\tborder: 1px solid #e2e9f2;\n\t\tborder-radius: 10px;\n\t\tpadding: 0;\n\t\tmargin-bottom: 12px;\n\n\t\t.table {\n\t\t\tborder-collapse: collapse;\n\n\t\t\t.column-heading {\n\t\t\t\tbackground: #fbfcfe;\n\t\t\t\tcolor: #7d8a9d;\n\t\t\t\tfont-size: 10px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\ttext-transform: none;\n\t\t\t\tpadding: 12px 16px;\n\t\t\t\tborder-bottom: 1px solid #edf1f6;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\n\t\t\t.table-body .table-row {\n\t\t\t\tborder-bottom: 1px solid #edf1f6;\n\n\t\t\t\t&:last-child {\n\t\t\t\t\tborder-bottom: 0;\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: #fcfdff;\n\t\t\t\t}\n\n\t\t\t\ttd {\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\tline-height: 18px;\n\t\t\t\t\tcolor: #253750;\n\t\t\t\t\tpadding: 12px 16px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Meta tags\n\t.tag-cover-box {\n\t\tborder: 1px solid #dce5ef;\n\t\tborder-radius: 7px;\n\t\tmin-height: 52px;\n\n\t\t.grey-box {\n\t\t\tbackground: #f1f6fd;\n\t\t\tborder: 0;\n\t\t\tborder-radius: 20px;\n\t\t\tcolor: #3d5a80;\n\t\t\tfont-size: 11px;\n\t\t\tmargin: 8px 6px;\n\t\t}\n\t}\n\n\t// Footer actions\n\t.product-bottom-container {\n\t\tmargin-top: 16px;\n\t\tpadding-top: 16px;\n\t\tborder-top: 1px solid #edf1f6;\n\n\t\t.next-button {\n\t\t\tmin-width: 110px;\n\t\t}\n\t}\n}\n\n// ng-select (Sub category) styled like mat outlined fields\n.custom-dropdown-icon {\n\tposition: relative;\n\n\t.select-label-text {\n\t\tposition: absolute;\n\t\ttop: -7px;\n\t\tinset-inline-start: 10px;\n\t\tz-index: 2;\n\t\twidth: auto !important;\n\t\theight: auto !important;\n\t\tmax-width: calc(100% - 24px);\n\t\tmargin: 0 !important;\n\t\tborder: 0 !important;\n\t\tbox-shadow: none !important;\n\t\twhite-space: nowrap;\n\t\tpadding: 0 4px !important;\n\t\tbackground: #fff;\n\t\tcolor: #7d8a9d !important;\n\t\tfont-size: 11px !important;\n\t\tline-height: 14px;\n\t\ttext-transform: none !important;\n\n\t\t.pl-10 {\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t.required-text {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\tng-select {\n\t\ttop: 0 !important;\n\t\tmargin: 0 !important;\n\t}\n\n\t::ng-deep .ng-select {\n\t\t.ng-select-container {\n\t\t\tmargin-top: 0 !important; // global .ng-select.select-input adds 1.75rem\n\t\t\tmin-height: 41px !important;\n\t\t\theight: 41px !important;\n\t\t\tborder: 1px solid #dce5ef !important;\n\t\t\tborder-radius: 7px !important;\n\t\t\tbackground: #fff;\n\t\t\tbox-shadow: none !important;\n\t\t\tcolor: #253750;\n\t\t\tfont-size: 13px;\n\t\t}\n\n\t\t&.ng-select-focused .ng-select-container {\n\t\t\tborder-color: var(--primary-color) !important;\n\t\t}\n\n\t\t&.ng-select-disabled .ng-select-container {\n\t\t\tbackground: #fff;\n\t\t\tborder-color: #e2e9f2 !important;\n\n\t\t\t.ng-value-label {\n\t\t\t\tcolor: #8491a3;\n\t\t\t}\n\t\t}\n\n\t\t.ng-value-container {\n\t\t\tpadding-inline-start: 15px !important;\n\t\t}\n\t}\n}\n\n// ---------------------------------------------------------------------\n// Sub category (ng-select) invalid state, same red as mat fields\n.custom-dropdown-icon:has(.error-msg) {\n\t.select-label-text,\n\t.select-label-text span {\n\t\tcolor: #c34242 !important;\n\t}\n\n\t::ng-deep .ng-select .ng-select-container {\n\t\tborder-color: #c34242 !important;\n\t}\n}\n\n// ---------------------------------------------------------------------\n// One continuous 2-column grid for the whole form, so single fields\n// (brand, material type, ...) pair up instead of leaving half-empty rows\n// ---------------------------------------------------------------------\n.product-detail-container .form-container > form {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, minmax(0, 1fr));\n\tcolumn-gap: 16px;\n\talign-items: start;\n\n\t> * {\n\t\tgrid-column: 1 / -1;\n\t\tmin-width: 0;\n\t}\n\n\t> .product-input-wrap {\n\t\tdisplay: contents;\n\n\t\t> .form-inputs {\n\t\t\tgrid-column: auto;\n\t\t}\n\n\t\t> .width-100 {\n\t\t\tgrid-column: 1 / -1;\n\t\t}\n\t}\n\n\t// float wrappers used for the tag/related \"Save\" buttons\n\t> .editTag-ltr,\n\t> .editTag-rtl,\n\t> .saveRelated {\n\t\tfloat: none;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\theight: auto;\n\t\tmargin: 0;\n\t\tpadding-bottom: 0;\n\n\t\t.form-inputs {\n\t\t\tpadding-bottom: 12px;\n\n\t\t\t&:empty {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\t&:not(:has(button)) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n// Related products accordion: the class is on both mat-accordion and the\n// inner div, so its old padding/background applied twice\n.product-detail-container mat-accordion.relatedProduct {\n\tpadding: 0 !important;\n\tmargin: 4px 0 12px !important;\n\tbackground: transparent !important;\n\tborder: 0 !important;\n\tbox-shadow: none !important;\n\n\t&::before,\n\t&::after {\n\t\tdisplay: none !important;\n\t}\n}\n\n// Upload boxes already show the empty state - hide the big \"No Data Found\"\n.product-detail-container .img-wrap .loader-style {\n\tdisplay: none;\n}\n\n// Empty related list: no table frame / scroll area, just the empty state box\n.product-detail-container .relatedProduct .listing-table:not(:has(table)) {\n\tborder: 0;\n\toverflow: visible;\n\tmax-height: none;\n\tmargin-bottom: 0;\n\tpadding: 0;\n}\n\n// Related products empty state: compact, like list-page .empty-state\n.product-detail-container .relatedProduct .loader-style {\n\tborder: 1px dashed #dce5ef;\n\tborder-radius: 10px;\n\tpadding: 28px 12px;\n\ttext-align: center;\n\tcolor: #8491a3;\n\tfont-size: 11px;\n\tmin-height: 0 !important;\n\theight: auto !important;\n}\n\n// Consistent field labels (translations mix \"brand*\", \"Product unit *\", \"SKU\")\n.product-detail-container {\n\t::ng-deep .mat-mdc-form-field .mdc-floating-label,\n\t::ng-deep .mat-mdc-form-field mat-label,\n\t.select-label-text {\n\t\ttext-transform: uppercase !important;\n\t\tletter-spacing: .3px;\n\t}\n}\n\n// Meta tag input + inline \"Add Tag\" button\n.addTag-Btn-ltr,\n.addTag-Btn-rtl {\n\ttop: 3px !important;\n\t--mdc-filled-button-container-height: 35px !important;\n}\n\n.addTag-Btn-ltr {\n\tright: 3px !important;\n}\n\n.addTag-Btn-rtl {\n\tleft: 3px !important;\n}\n\n.product-detail-container .tag-cover-box {\n\tmin-height: 41px;\n\talign-items: center;\n}\n\n// ---------------------------------------------------------------------\n// Theme tokens: every colour on this page comes from the theme config\n// (ThemeConfigurationService -> --primary-color, --primary-font-color,\n// --secondary-grey-color, --grey-border). Hex values are only fallbacks.\n// ---------------------------------------------------------------------\n:host {\n\t--pd-ink: var(--primary-font-color, #172b46);\n\t--pd-text: var(--primary-font-color, #253750);\n\t--pd-muted: var(--secondary-grey-color, #7d8a9d);\n\t--pd-border: color-mix(in srgb, var(--grey-border, #D5D7DA) 70%, white);\n\t--pd-divider: color-mix(in srgb, var(--grey-border, #D5D7DA) 45%, white);\n\t--pd-soft: color-mix(in srgb, var(--primary-color) 4%, white);\n\n\tcolor: var(--pd-text);\n\t--mdc-outlined-text-field-outline-color: var(--pd-border);\n\t--mdc-outlined-text-field-label-text-color: var(--pd-muted);\n\t--mdc-outlined-text-field-input-text-color: var(--pd-text);\n\t--mdc-outlined-text-field-disabled-outline-color: var(--pd-divider);\n}\n\n.product-detail-container {\n\t.form-container,\n\t.listing-table,\n\t.mat-accordion .mat-expansion-panel,\n\t.img-wrap .uploaded-image-container .image-card {\n\t\tborder-color: var(--pd-border);\n\t}\n\n\t.img-wrap,\n\t.product-input-wrap .checkbox-wrap,\n\t.product-bottom-container,\n\t.listing-table .table .column-heading,\n\t.listing-table .table .table-body .table-row {\n\t\tborder-color: var(--pd-divider);\n\t}\n\n\t.product-input-wrap .checkbox-wrap .border_class,\n\t.tag-cover-box,\n\t.relatedProduct .loader-style,\n\t.img-wrap .uploaded-image-container .upload-wrap {\n\t\tborder-color: var(--pd-border);\n\t}\n\n\t.img-wrap h2,\n\t.upload-heading,\n\t.title3,\n\t.product-input-wrap .checkbox-wrap .title3,\n\t.mat-accordion .accordian-label,\n\t.listing-table .table .table-body .table-row td {\n\t\tcolor: var(--pd-ink);\n\t}\n\n\t.product-input-wrap .checkbox-wrap .label2,\n\t.listing-table .table .column-heading,\n\t.relatedProduct .loader-style {\n\t\tcolor: var(--pd-muted);\n\t}\n\n\t.tag-cover-box .grey-box {\n\t\tbackground: color-mix(in srgb, var(--primary-color) 8%, white);\n\t\tcolor: color-mix(in srgb, var(--primary-color) 70%, black);\n\t}\n\n\t.img-wrap .uploaded-image-container .image-card,\n\t.img-wrap .uploaded-image-container .upload-wrap div,\n\t.listing-table .table .column-heading {\n\t\tbackground: var(--pd-soft);\n\t}\n}\n\n.custom-dropdown-icon {\n\t.select-label-text,\n\t.select-label-text span {\n\t\tcolor: var(--pd-muted) !important;\n\t}\n\n\t// selected value (global ng-select styles hard-code greys)\n\t::ng-deep .ng-select .ng-value .ng-value-label,\n\t::ng-deep .ng-select .ng-value span {\n\t\tcolor: var(--pd-text) !important;\n\t}\n\n\t::ng-deep .ng-select.ng-select-disabled .ng-value .ng-value-label,\n\t::ng-deep .ng-select.ng-select-disabled .ng-value span {\n\t\tcolor: var(--pd-muted) !important;\n\t}\n\n\t::ng-deep .ng-select .ng-select-container {\n\t\tborder-color: var(--pd-border) !important;\n\t\tcolor: var(--pd-text);\n\t}\n\n\t::ng-deep .ng-select.ng-select-focused .ng-select-container {\n\t\tborder-color: var(--primary-color) !important;\n\t}\n}\n\n// Mobile / narrow content (sidebar open)\n@mixin single-column {\n\t.product-detail-container {\n\t\t.form-container {\n\t\t\tpadding: 16px;\n\t\t}\n\n\t\t.form-container > form,\n\t\t.product-input-wrap,\n\t\t.product-input-wrap .checkbox-wrap .d-flex,\n\t\t.relatedProduct .product-input-wrap {\n\t\t\tgrid-template-columns: minmax(0, 1fr);\n\t\t}\n\n\t\t// Related products: sub category full width, search + icons on one row\n\t\t.relatedProduct .product-input-wrap {\n\t\t\tgrid-template-columns: minmax(0, 1fr) auto;\n\n\t\t\t> .form-inputs:first-child {\n\t\t\t\tgrid-column: 1 / -1;\n\t\t\t}\n\t\t}\n\n\t\t.relatedProduct .filters-icon {\n\t\t\tjustify-content: flex-end;\n\t\t\tpadding-bottom: 16px;\n\t\t\talign-self: center;\n\t\t\tgap: 6px;\n\t\t}\n\n\t\t// Inner card adds a second frame on phones - flatten it\n\t\t.form-container {\n\t\t\tborder: 0;\n\t\t\tpadding: 4px 0 0;\n\t\t}\n\n\t\t.img-wrap .uploaded-image-container .image-card {\n\t\t\twidth: 130px;\n\t\t\theight: 130px;\n\t\t\tmin-height: 130px;\n\t\t\tmax-height: 130px;\n\t\t}\n\t}\n}\n\n@media (max-width: 768px) {\n\t@include single-column;\n}\n\n@container (max-width: 640px) {\n\t@include single-column;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
